var during = 150;
var open = false;
$(function() {
  var items = $('.menulist .item')
    .click(function() {
      var self = $(this);
      if (self.hasClass('current')) {
        items
          .removeClass('current')
          .find('.submenu')
          .stop(true)
          .slideUp();
      } else {
        items.removeClass('current');
        self.addClass('current');
        items
          .find('.submenu')
          .stop(true)
          .slideUp();
        self
          .stop(true)
          .find('.submenu')
          .slideDown();
      }
    })
    .each(function() {
      var self = $(this);
      self.find('span').each(function() {
        $(this).html('&nbsp;&nbsp;&nbsp;' + $(this).html());
      });
      self.find('.submenu > a').click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        items.find('a.open').removeClass('open');
        var aself = $(this);
        setTimeout(() => {
          aself.addClass('open');
        }, 100);
        return false;
      });
    });
  $('.menubutton').click(function() {
    $('.menu .getsearch').hide();
    if (open) {
      $('.main .content .menu .menucontent').hide();
      $('.main .content .menu').removeClass('active');
      $('.main .content .maincontent').show();
      open = false;
    } else {
      $('.main .content .menu').addClass('active');
      $('.main .content .menu .menucontent').css({ display: 'flex' });
      $('.main .content .maincontent').hide();
      open = true;
    }
  });
  $('.menucontent .leftm > div').each(function(i) {
    var self = $(this).click(function() {
      $('.menucontent .leftm > div').removeClass('active');
      $('.menucontent .rightm > div')
        .hide()
        .eq(i)
        .show();
      self.addClass('active');
    });
  });
  $('.menucontent .rightm').click(function() {
    $('.main .content .menu .menucontent').hide();
    $('.main .content .menu').removeClass('active');
    $('.main .content .maincontent').show();
  });

  $('.rightsearch').click(function() {
    $('.getsearch input').val('');
  });

  $('.searchbutton').click(function() {
    var block = $('.menu .getsearch');
    if (block.css('display') == 'none') {
      block.slideDown({
        duration: during,
        start: function() {
          $(this).css({ display: 'flex' });
        }
      });
    } else {
      block.slideUp(during);
    }
  });

  $('.maincontent').click(function() {
    if ($('.menu .getsearch').css('display') != 'none') {
      $('.menu .getsearch').slideUp(during);
    }
  });
});
var settop = function() {
  $('.maincontent').scrollTop(0);
  $(window).scrollTop(0);
};
var setlink = function(context) {
  if (open) {
    $('.main .content .menu .menucontent').hide();
    $('.main .content .menu').removeClass('active');
    $('.main .content .maincontent').show();
    open = false;
  }
  $(window).scrollTop(0);
  $('.maincontent').scrollTop(0);
  var searchid = null;
  if (context.$route && context.$route.query.search != null) {
    var str = context.$route.query.search;
    str = str.replace(/<|>| /g, '');
    if (str) {
      var htmlcode = $('.container').html();
      var stack = {},
        i = 0;
      while (true) {
        if (htmlcode.indexOf(str) == -1) break;
        var keyid = 'keywordhightlight_' + ++i;
        htmlcode = htmlcode.replace(str, keyid);
        stack[keyid] =
          "<span class='keywordhightlight' id='" +
          keyid +
          "'>" +
          str +
          '</span>';
      }
      var result = false;
      for (var i in stack) {
        result = true;
        htmlcode = htmlcode.replace(i, stack[i]);
      }
      $('.container').html(htmlcode);
      if (result) {
        searchid = 'keywordhightlight_1';
      }
    }
  }
  let id;
  if (searchid != null) {
    id = searchid;
  } else if (typeof context == 'string') {
    id = context;
  } else if (typeof context.id == 'string'){
    id = context.id;
  }
  if (id != null) {
    if ($('#home > div.menu').css('display') != 'none') {
      $('.maincontent').scrollTop(0);
      setTimeout(function() {
        if($('.maincontent  #' + id).length > 0) {
          $('.maincontent').scrollTop(
            $('.maincontent  #' + id).offset().top -
              $('.maincontent').offset().top
          );
        }
      }, 150);
    } else {
      if($('.maincontent  #' + id).length > 0) {
        setTimeout(function() {
          $(window).scrollTop($('.maincontent  #' + id).offset().top);
        }, 150);
      }

    }
  }
};
var resizefunc = function(iframeID) {
  if ($('.maincontent').width() < 768) {
    var scale = parseInt(($('.maincontent').width() * 100) / 768) / 100;
    var w = parseInt((768 * (1 - scale)) / 2 / scale);
    var y = parseInt(scale * 100);

    $(iframeID).css(
      'transform',
      'scale(' + scale + ') translateX(-' + w + 'px) translateY(-' + y + 'px)'
    );
  } else {
    $(iframeID).css('transform', 'scale(1) translateX(0px) translateY(0px)');
  }
};
var imagehoverclick = function(imagedivid) {
  var container = $('#' + imagedivid);
  if (container.data('init') === true) return;
  var img = $('#' + imagedivid + ' img').get(0);
  var nImg = new Image();
  nImg.src = img.src;
  nImg.onload = function() {
    var width = nImg.width;
    var height = nImg.height;

    $('#' + imagedivid + ' map area').each(function(i, item) {
      var co = item.coords.split(',').map((x) => parseInt(x));
      container.append(
        $('<div>')
          .css({
            position: 'absolute',
            left: (co[0] / width) * 100 + '%',
            top: (co[1] / height) * 100 + '%',
            width: ((co[2] - co[0]) / width) * 100 + '%',
            height: ((co[3] - co[1]) / height) * 100 + '%',
            cursor: 'pointer'
            //,"background-color":'rgba(255,0,0,0.4)'
          })
          .click(function() {
            $(item).click();
          })
      );
    });
    $('#' + imagedivid + ' map').hide();
    container.data('init', true);
  };
};
window.imagehoverclick = imagehoverclick;
window.resizefunc = resizefunc;
window.setlink = setlink;
window.settop = settop;
